import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import Input from '../Inputs/Input/Input';
import Button from '../Button/Button';
import { colors } from '../../constants/colors';

/**
 * ÐÐ¾Ð¼Ð¿Ð°ÐºÑÐ½Ð°Ñ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Â«Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð½Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ°Â»: Ð¾ÑÐºÑÑÐ²Ð°ÐµÑÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Ð²
 * ÐºÐ¾Ð½ÑÐµ ÑÐ¿Ð¸ÑÐºÐ° ÑÐµÐ»ÐµÐºÑÐ°, ÑÑÐ¾Ð±Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ½Ð°ÑÐ°Ð»Ð° Ð¿Ð¾ÑÐ¼Ð¾ÑÑÐµÐ», ÐµÑÑÑ Ð»Ð¸ Ð½ÑÐ¶Ð½Ð¾Ðµ
 * Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ¾Ð¼ Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐ» ÑÐ²Ð¾Ñ â Ð½Ðµ ÑÑÐ¾Ð´Ñ Ñ ÑÐºÑÐ°Ð½Ð°.
 */
const DictionaryNameModal = ({ isOpen, onClose, title, fieldLabel, placeholder, context, saving, onSubmit }) => {
  const [name, setName] = useState('');

  // ÐÐ¾Ð´Ð°Ð»ÐºÐ° Ð½Ðµ ÑÐ°Ð·Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ Ð¼ÐµÐ¶Ð´Ñ Ð¾ÑÐºÑÑÑÐ¸ÑÐ¼Ð¸ â ÑÐ¸ÑÑÐ¸Ð¼ Ð¿Ð¾Ð»Ðµ ÑÐ°Ð¼Ð¸, Ð¸Ð½Ð°ÑÐµ Ð² Ð½ÐµÐ¹
  // Ð¾ÑÑÐ°ÑÑÑÑ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¾Ñ Ð¿ÑÐ¾ÑÐ»Ð¾Ð³Ð¾ ÑÐ°Ð·Ð°.
  useEffect(() => {
    if (isOpen) setName('');
  }, [isOpen]);

  const submit = () => {
    if (saving || !name.trim()) return;
    onSubmit(name);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} title={title} width="480px" contentStyle={{ top: '18%', bottom: 'auto' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {context && (
          <div style={{ fontFamily: "'Exo 2', sans-serif", fontSize: 13, color: colors.cameo }}>{context}</div>
        )}
        <Input
          label={fieldLabel}
          placeholder={placeholder}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          required
          autoFocus
        />
        <Button text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ" fill onClick={submit} disabled={saving || !name.trim()} />
      </div>
    </Modal>
  );
};

export default DictionaryNameModal;
